import { render } from "./MovingDivider.vue?vue&type=template&id=63c7d987"
import script from "./MovingDivider.vue?vue&type=script&lang=js"
export * from "./MovingDivider.vue?vue&type=script&lang=js"

import "./MovingDivider.vue?vue&type=style&index=0&id=63c7d987&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__